// @flow
import React from 'react';
import { useViewport } from 'components/templates/viewportProvider';
import styles from './styles.scss';

export const Title = props => {
  const { firstText, secondText } = props;
  const { isMobile } = useViewport();

  return (
    <div className={'title'}>
      <h3>
        Explore <span>{firstText}</span> {isMobile && <br />}
        available across
        <span> {secondText}</span>
      </h3>
    </div>
  );
};
